import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=36081e69&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36081e69",
  null
  
)

component.options.__file = "src/demo/pages/mall/goods.vue"
export default component.exports